export enum MaintenanceEnvironments {
  Alberta = 'Alberta',
  Mdr = 'Alberta (MDR)',
}
